import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Namespace } from '@wix/ambassador-metasite-api-v1-meta-site/types';
import { WixNamespace } from '../../commonTypes/WixNamespace';
import { BaseClient } from '../BaseClient';
export class MetasiteClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createSitelessMetaSiteImpl", void 0);
    _defineProperty(this, "deleteMetaSiteImpl", void 0);
    _defineProperty(this, "readApiGetImpl", void 0);
  }
  convertNamespaceToEnum(namespace) {
    switch (namespace) {
      case Namespace.UNKNOWN_NAMESPACE:
        return WixNamespace.UNKNOWN_NAMESPACE;
      case Namespace.WIX:
        return WixNamespace.WIX;
      case Namespace.SHOUT_OUT:
        return WixNamespace.SHOUT_OUT;
      case Namespace.ALBUMS:
        return WixNamespace.ALBUMS;
      case Namespace.WIX_STORES_TEST_DRIVE:
        return WixNamespace.WIX_STORES_TEST_DRIVE;
      case Namespace.HOTELS:
        return WixNamespace.HOTELS;
      case Namespace.CLUBS:
        return WixNamespace.CLUBS;
      case Namespace.ONBOARDING_DRAFT:
        return WixNamespace.ONBOARDING_DRAFT;
      case Namespace.DEV_SITE:
        return WixNamespace.DEV_SITE;
      case Namespace.LOGOS:
        return WixNamespace.LOGOS;
      case Namespace.VIDEO_MAKER:
        return WixNamespace.VIDEO_MAKER;
      case Namespace.PARTNER_DASHBOARD:
        return WixNamespace.PARTNER_DASHBOARD;
      case Namespace.DEV_CENTER_COMPANY:
        return WixNamespace.DEV_CENTER_COMPANY;
      case Namespace.HTML_DRAFT:
        return WixNamespace.HTML_DRAFT;
      case Namespace.SITELESS_BUSINESS:
        return WixNamespace.SITELESS_BUSINESS;
      case Namespace.CREATOR_ECONOMY:
        return WixNamespace.CREATOR_ECONOMY;
      case Namespace.DASHBOARD_FIRST:
        return WixNamespace.DASHBOARD_FIRST;
      case Namespace.ANYWHERE:
        return WixNamespace.ANYWHERE;
      case Namespace.HEADLESS:
        return WixNamespace.HEADLESS;
      case Namespace.ACCOUNT_MASTER_CMS:
        return WixNamespace.ACCOUNT_MASTER_CMS;
      case Namespace.RISE:
        return WixNamespace.RISE;
      case Namespace.BRANDED_FIRST:
        return WixNamespace.BRANDED_FIRST;
      case Namespace.NOWNIA:
        return WixNamespace.NOWNIA;
      case Namespace.UGC_TEMPLATE:
        return WixNamespace.UGC_TEMPLATE;
      case Namespace.CODUX:
        return WixNamespace.CODUX;
      case Namespace.MEDIA_DESIGN_CREATOR:
        return WixNamespace.MEDIA_DESIGN_CREATOR;
      default:
        return WixNamespace.UNKNOWN_NAMESPACE;
    }
  }
  async createMetasite(name, namespace) {
    if (namespace === void 0) {
      namespace = WixNamespace.NOWNIA;
    }
    try {
      this.logInfo('createMetasite', 'entry', {
        name,
        namespace
      });
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      const {
        metaSite
      } = await this.request(this.createSitelessMetaSiteImpl({
        namespace: namespace,
        name: name.toLocaleLowerCase().substring(0, 20)
      }), ...args);
      this.logDebug('createMetasite', 'createSitelessMetaSite - response', {
        metaSite
      });
      if (!metaSite) {
        throw new Error('Error creating a business site');
      }
      return metaSite;
    } catch (error) {
      this.logError('createMetasite', 'Failed to create metasite', {
        name,
        namespace
      }, error);
      throw error;
    }
  }
  async deleteMetaSite(metaSiteId) {
    try {
      this.logInfo('deleteMetaSite', 'entry', {
        metaSiteId
      });
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.deleteMetaSiteImpl({
        metaSiteId
      }), ...args);
    } catch (error) {
      this.logError('deleteMetaSite', 'Failed to delete metasite', {
        metaSiteId
      }, error);
      throw error;
    }
  }

  // Note: getOwnerId uses different APIs in RPC (getBulk) vs HTTP (readApiGet)
  // RPC: getBulk takes metaSiteIds explicitly in request
  // HTTP: readApiGet gets metaSiteId from aspects/signed identity
  // So we make it abstract and implement separately

  // Note: search and getClientSpecMap don't have HTTP equivalents, so they remain abstract
  // and will be implemented differently in RPC vs HTTP versions

  async getAppSignedInstance(appId, metaSiteId, aspects) {
    try {
      this.logInfo('getAppSignedInstance', 'entry', {
        appId,
        metaSiteId
      });
      for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        args[_key3 - 3] = arguments[_key3];
      }
      const clientSpecMap = await this.getClientSpecMap(metaSiteId, aspects, ...args);
      const {
        instance
      } = Object.values(clientSpecMap).find(spec => spec.appDefinitionId === appId) || {};
      this.logInfo('getAppSignedInstance', 'instance', {
        instance
      });
      if (!instance) {
        throw new Error('Error getting signed instance');
      }
      return instance;
    } catch (error) {
      this.logError('getAppSignedInstance', 'Failed to get app signed instance', {
        appId,
        metaSiteId
      }, error);
      throw error;
    }
  }

  // getVisitorSignedInstance uses direct HTTP calls and doesn't follow the standard pattern
  // It will be implemented in each concrete class

  convertToEntity(metaSite) {
    if (!metaSite) {
      throw new Error('MetaSite is required');
    }
    return metaSite;
  }
  getServiceNameForLogs() {
    return 'MetasiteClient';
  }
}
//# sourceMappingURL=MetasiteClientBase.js.map